<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Sidebar -->
    <Sidebar :is-open="isSidebarOpen" @toggle="toggleSidebar" />

    <!-- Contenu principal -->
    <div class="flex flex-col flex-1" :class="{ 'lg:pl-64': isSidebarOpen }">
      <!-- En-tête -->
      <header class="bg-white shadow-sm">
        <div
          class="flex items-center justify-between h-16 px-4"
          style="height: 5em"
        >
          <button
            type="button"
            class="text-gray-500 hover:text-[#B70018] focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#B70018]"
            @click="toggleSidebar"
          >
            <span class="sr-only">Ouvrir le menu</span>
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <div class="h-full flex flex-shrink-0 items-center">
            <img
              src="/images/logo-agco.svg"
              alt="Logo AGCO"
              class="h-16 w-auto"
            >
          </div>
        </div>
      </header>

      <!-- Contenu -->
      <main class="flex-1">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import Sidebar from "@/components/layout/Sidebar.vue";
import { ref } from "@vue/runtime-core";

const isSidebarOpen = ref<boolean>(true);

const toggleSidebar = (): void => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

defineOptions({
  name: "Dashboard",
});
</script>
